import { ILocation } from 'redhotpie-shared-lib/interfaces/IGroup';
import { utils } from '../functions';
import timezone from './timezone';
import { ITimezone } from 'redhotpie-shared-lib/interfaces/ITimezone';
import { IEventUser } from 'redhotpie-shared-lib/interfaces/IEvent';

export default class eventUser {
  eventId: number;
  eventTitle: string;
  dateHeld: string;
  dateHeldDisplay: string;
  approvalStatus: string;
  eventBannerUrl: string;
  interestCount: number;
  location?: ILocation;
  dateHeldUtcIso: any;
  dateHeldUtcIsoEx: string;
  timezone?: ITimezone;
  eventType: string;
  ageMax?: number;
  ageMin?: number;

  constructor() {
    this.eventId = 0;
    this.eventTitle = '';
    this.dateHeld = '';
    this.dateHeldDisplay = '';
    this.approvalStatus = '';
    this.eventBannerUrl = '';
    this.interestCount = 0;
    this.location = undefined;
    this.dateHeldUtcIso = '';
    this.dateHeldUtcIsoEx = '';
    this.timezone = undefined;
    this.eventType = '';
  }

  static mappingObjectLocation(object: any): ILocation {
    const newObject = {
      city: '',
      state: '',
      country: '',
      stateAbbr: '',
    };
    newObject.city = object && object.City ? object.City : '';
    newObject.state = object && object.State ? object.State : '';
    newObject.country = object && object.Country ? object.Country : '';
    newObject.stateAbbr = object && object.StateAbbr ? object.StateAbbr : '';
    return newObject;
  }

  static mappingObject(event: any): IEventUser {
    const profile = new eventUser();
    profile.ageMax = event.AgeMax;
    profile.ageMin = event.AgeMin;
    profile.eventId = event.EventID ? event.EventID : null;
    profile.eventTitle = event.EventTitle ? event.EventTitle : '';
    profile.dateHeld = event.DateHeld ? event.DateHeld : '';
    profile.dateHeldDisplay = event.DateHeldDisplay ? event.DateHeldDisplay : '';
    profile.approvalStatus = event.ApprovalStatus ? event.ApprovalStatus : '';
    profile.eventBannerUrl = event.EventBannerUrl ? event.EventBannerUrl : '';
    profile.interestCount = event.InterestCount ? event.InterestCount : 0;
    profile.location = event.Location ? this.mappingObjectLocation(event.Location) : undefined;
    profile.timezone = event.TimeZone ? timezone.mappingObject(event.TimeZone) : undefined;
    profile.dateHeldUtcIso = event.DateHeldUtcIso
      ? utils.formatDateTimeWithTimezone(
          event.DateHeldUtcIso,
          profile.timezone && profile.timezone.hasOwnProperty('ianaName') ? profile.timezone.ianaName : ''
        )
      : '';
    profile.dateHeldUtcIsoEx = event.DateHeldUtcIso;
    profile.eventType = event.EventType || '';
    return profile;
  }

  static mappingObjectsCustomMember(_event: any): IEventUser[] {
    const users: IEventUser[] = [];
    _event.forEach((ev: any) => {
      const user = eventUser.mappingObject(ev.eventUser || ev);
      users.push(user);
    });
    return users;
  }
}
